import API_URLS from '../../config/BackendConfig';
import { getToken } from '../../utils/tokenUtils';
import { postRequest , getRequest} from '../../config/AxiosConfig';

const apiBaseUrlProd = API_URLS.PROD;
const apiBaseUrlCostomber = API_URLS.CUSTOMER;

const getAuthHeaders = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const createMandate = async (payload, onAfterRequest = () => {}) => {
  try {
    const response = await postRequest({
      url: apiBaseUrlProd + "auto-debit-r/mandate/create",
      headers: getAuthHeaders(),
      data: payload,
      onAfterRequest,
    });

    return response;
  } catch (error) {
    console.error(
      "Error creating mandate:",
      error.response?.data || error.message
    );
    throw error;
  }
};

// MandateService.js
export const getMandateTable = async ({
  page = 1,
  per_page = 10,
  search = "",
  status = "",
}) => {
  try {
    const response = await postRequest({
      url: apiBaseUrlCostomber + "auto-debit-r/mandates?page=" + page,
      headers: getAuthHeaders(),
      data: {
        search,
        status,
        per_page,
      },
    });
   
 
    // ✅ RETURN CLEAN STRUCTURE
    return {
      data: response?.data,         // <-- ARRAY
      pagination: response?.pagination,
    };
   
  } catch (error) {
    console.error(
      "Error fetching mandates:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const refreshMandateById = async (payload) => {
  try {
    const response = await postRequest({
      url: apiBaseUrlProd + "auto-debit-r/mandate/refresh",
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error fetching mandate:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getMandateById = async (payload) => {
  try {
    const response = await postRequest({
      url: apiBaseUrlProd + "auto-debit-r/mandate/get",
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error fetching mandate:",
      error.response?.data || error.message
    );
    throw error;
  }
};



export const deleteMandateById = async (payload) => {
  try {
    const response = await postRequest({
      url: apiBaseUrlProd + "auto-debit-r/mandate/delete",
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      error.response?.data || error.message
    );
    throw error;
  }
};


export const cancelMandateById = async (payload) => {
  try {
    const response = await postRequest({
      url: apiBaseUrlProd + "auto-debit-r/mandate/cancel",
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      error.response?.data || error.message
    );
    throw error;
  }
};